import { AdminTemplate, MerchantBankAddForm } from "../../components"

export const MerchantBankAdd = () => {
  return (
    <AdminTemplate
      headerProps={{
        headerTitle: 'Üye İşyeri Banka Tanımlama',
        hideAddButton: true,
        hideDownloadButton: true,
        hideSearchBar: true
      }}>
      <MerchantBankAddForm />
    </AdminTemplate>
  )
}